import type { TrialStatus } from "@/types";
import { type ApiRequestOptions, apiJson } from "./apiClient";

export type GrantCreditsRequest = {
	profileId: string;
	amountCredits: string | number;
};

export type GrantCreditsResponse = {
	profileId: string;
	creditBalance: string;
};

export type AdminProfile = {
	id: string;
	role: "USER" | "ADMIN";
	creditBalance: string;
	name: string | null;
	trialStatus: TrialStatus | null;
	trialEndsAt: string | null;
	createdAt: string;
	updatedAt: string;
};

export type ListProfilesResponse = {
	items: AdminProfile[];
	nextCursor: string | null;
};

export async function grantCredits(
	body: GrantCreditsRequest,
	options?: ApiRequestOptions,
): Promise<GrantCreditsResponse> {
	return apiJson<GrantCreditsResponse>("/admin/credits/grant", {
		method: "POST",
		body: JSON.stringify(body),
		signal: options?.signal,
	});
}

export async function listProfiles(
	params: { limit?: number; cursor?: string } = {},
	options?: ApiRequestOptions,
): Promise<ListProfilesResponse> {
	const qs = new URLSearchParams();
	if (params.limit) qs.set("limit", String(params.limit));
	if (params.cursor) qs.set("cursor", params.cursor);
	const suffix = qs.toString() ? `?${qs.toString()}` : "";
	return apiJson<ListProfilesResponse>(`/admin/profiles${suffix}`, {
		signal: options?.signal,
	});
}

export async function updateTrialStatus(
	params: {
		profileId: string;
		status: TrialStatus;
	},
	options?: ApiRequestOptions,
): Promise<{
	id: string;
	status: TrialStatus;
	startedAt: string;
	endsAt: string | null;
	createdAt: string;
	updatedAt: string;
}> {
	return apiJson(`/admin/profiles/${params.profileId}/trial`, {
		method: "PATCH",
		body: JSON.stringify({ status: params.status }),
		signal: options?.signal,
	});
}
